import { SaleDetailModel } from 'api-hooks/sale/model';
import { guestNameTransformer } from 'legacy-modules/sales/ticket-sale/hooks/use-get-default-values';
import React from 'react';

import {
  CruiseRescheduleFormType,
  CruiseSaleAddOnsType,
  CruiseSaleDetailType,
  CruiseSaleGuestType,
  CruiseSaleType,
} from '../form-type';

interface Props {
  cruiseSale: SaleDetailModel;
}

export default function useGetDefaultValues(props: Props) {
  const { cruiseSale } = props;

  const defaultValues = React.useMemo<CruiseRescheduleFormType>(() => {
    const cruiseSales: CruiseSaleType[] = cruiseSale.cruiseSales.map((cs) => {
      //guest
      const cruiseSaleGuests: CruiseSaleGuestType[] = cs.cruiseSaleGuests.map(
        (csg) => ({
          guestId: csg.guest.id,
          id: csg.id,
          isSelected: false,
          preferences: [],
          guestName: guestNameTransformer(csg.guest),
        }),
      );
      // details
      const cruiseSaleDetails: CruiseSaleDetailType[] =
        cs.cruiseSaleDetails.map((csd) => {
          const guest = cs.cruiseSaleGuests.find(
            (csg) => csg.id === csd.cruiseSaleGuestId,
          )?.guest;
          return {
            basicFare: csd.basicFare,
            cruiseRoomId: csd.cruiseRoom.id,
            cruiseRoomNumber: csd.cruiseRoomNumber,
            deck: csd.deck,
            description: csd.description,
            guestId: guest?.id || '',
            id: csd.id,
            isSelected: false,
            portCharge: csd.portCharge,
            tax: csd.tax,
            tipping: csd.tipping,
            guestName: cs.isGroupedPrice
              ? cs.cruiseSaleGuests
                  .map((g) => guestNameTransformer(g.guest))
                  .join(', ')
              : guestNameTransformer(guest!),
          };
        });
      //addons
      const cruiseSaleAddOns: CruiseSaleAddOnsType[] = cs.cruiseSaleAddOns.map(
        (csao) => ({
          description: csao.description,
          guestId: csao.guest.id,
          isSelected: false,
          price: csao.price,
          id: csao.id,
        }),
      );

      const informationCruiseSale = {
        bookingCode: cs.bookingCode,
        cruiseId: cs.cruise.id,
        cruiseShipId: cs.cruiseShip?.id,
        endedAt: cs.endedAt,
        startedAt: cs.startedAt,
        id: cs.id,
        isSelected: false,
        isGroupedPrice: cs.isGroupedPrice,
        reminder: cs.reminder,
        reminderDate: cs.reminderDate,
        reminderDescription: cs.reminderDescription,
        route: cs.route,
        cruiseName: cs.cruise.name,
        cruiseShipName: cs.cruiseShip?.name,
        cruiseRooms: cs.cruise.cruiseRooms.map((room) => ({
          id: room.id,
          label: `${room.type} (${room.size})`,
        })),
      };
      const detailsCruiseSale = {
        cruiseSaleAddOns,
        cruiseSaleGuests,
        cruiseSaleDetails,
      };
      return {
        ...informationCruiseSale,
        ...detailsCruiseSale,
        originalCruiseSale: informationCruiseSale,
        originalDetails: detailsCruiseSale,
      };
    });
    return {
      customer: [
        cruiseSale.customer.name,
        cruiseSale.customer.alias,
        cruiseSale.customer.phone,
      ]
        .filter((val) => !!val)
        .join(' - '),
      cruiseSales,
      invoiceNumber: cruiseSale.invoiceNumber,
      transactionAt: new Date(),
      total: 0,
    };
  }, [cruiseSale]);

  return defaultValues;
}
